<div class="allcp-form theme-primary mw400 auth-page" ng-init="registerInit()">
	<a href="/driver" class="header-logo" target="__BLANK">
		<img src="/landing/img/driver-logo.svg" alt="HODXpress Login" class="img img-responsive" style="margin:0 auto;">
	</a>
	<div class="mv400 stepper-wrapper">
		<ul class="stepper" ng-class="registerStep == 7 ? 'success' : ''">
			<li ng-class="registerStep == 1 ? 'selected' : ''"><a href="#">1</a></li>
			<li ng-class="registerStep == 2 ? 'selected' : ''"><a href="#">2</a></li>
			<li ng-class="registerStep == 3 ? 'selected' : ''"><a href="#">3</a></li>
			<li ng-class="registerStep == 4 ? 'selected' : ''"><a href="#">4</a></li>
			<li ng-class="registerStep == 5 ? 'selected' : ''"><a href="#">5</a></li>
			<li ng-class="registerStep == 6 ? 'selected' : ''"><a href="#">6</a></li>
			<li ng-class="registerStep == 7 ? 'selected success' : 'hidden'"><a href="#">7</a></li>
		</ul>
	</div>
	<div class="panel mw400" >
		<div class="panel-body register pn mv10" ng-class="registerStep == 7 ? 'success' : ''">
			<form id="registerForm" name="registerPageForm" class="form-validation" role="form" ng-submit="register(false)">
				<div class="inner-register-formf" ng-if="registerStep == 1">
					<h3>Tell Us About Yourself </h3>
					<div class="section">
						<input type="text" class="gui-input" placeholder="First Name" ng-model="registerForm.first_name" required>
					</div>
					<div class="section">
						<input type="text" class="gui-input" placeholder="Middle Name" ng-model="registerForm.middle_name" ng-required="!middle_name_status" ng-disabled="middle_name_status">
					</div>
					<div class="section">
						<label class="option option-info block mn ml4">
							<input type="checkbox" name="deleted" ng-model="middle_name_status">
							<span class="checkbox mn"></span> <span style="color:#828c95">I do not have a middle name</span>
						</label>
					</div>
					<div class="section">
						<input type="text" class="gui-input" placeholder="Last Name" ng-model="registerForm.last_name" required>
					</div>
				</div>
				<div class="inner-register-formf" ng-if="registerStep == 2">
					<h3>Address Info  </h3>
					<div class="section">
						<input type="text" class="gui-input" placeholder="Street" ng-model="registerForm.address" required>
					</div>
					<div class="section">
						<input type="text" class="gui-input" placeholder="Apt, Suite, Building" ng-model="registerForm.address2">
					</div>
					<div class="section">
						<input type="text" class="gui-input" placeholder="City" ng-model="registerForm.city" required>
					</div>
					<div class="section">
						<select ng-model="registerForm.state" class="gui-input" placeholder="State" required>
							<option value="">Select State</option>
							<option value="{{ state.name }}" ng-repeat="state in states track by $index">{{ state.name }}</option>
						</select>
					</div>
					<div class="section">
						<input type="text" class="gui-input" placeholder="Zipcode" ng-model="registerForm.zipcode" required>
					</div>
				</div>
				<div class="inner-register-form" ng-if="registerStep == 3">
					<h3>Vehicle Info  </h3>
					<div class="section vehicle-type">
						<!-- <p ng-class="!registerForm.vehicle_type && showErrorMessage ? 'error' : ''">Please choose your vehicle type</p> -->
						<p style="color: #30bfc9;">Please choose your vehicle type</p>
						<div class="row">
							<div class="col-md-12 mb-3">
								<button 
									type="button" 
									ng-click="registerForm.vehicle_type = 'Scooter'" 
									ng-class="registerForm.vehicle_type == 'Scooter' ? 'blue' : ''" 
									class="hod-button">
									Scooter
								</button>
								<button 
									type="button" 
									ng-click="registerForm.vehicle_type = 'Bike'" 
									ng-class="registerForm.vehicle_type == 'Bike' ? 'blue' : ''" 
									class="hod-button">
									Bike
								</button>
								<button 
									type="button" 
									ng-click="registerForm.vehicle_type = 'Motorcycle'" 
									ng-class="registerForm.vehicle_type == 'Motorcycle' ? 'blue' : ''" 
									class="hod-button">
									Motorcycle
								</button>
							</div>
							<div class="col-md-12">
								<button 
									type="button" 
									ng-click="registerForm.vehicle_type = 'Car'" 
									ng-class="registerForm.vehicle_type == 'Car' ? 'blue' : ''" 
									class="hod-button">
									Car
								</button>
								<button 
									type="button" 
									ng-click="registerForm.vehicle_type = 'Suv'" 
									ng-class="registerForm.vehicle_type == 'Suv' ? 'blue' : ''" 
									class="hod-button">
									Suv
								</button>
								<button 
									type="button" 
									ng-click="registerForm.vehicle_type = 'Van'" 
									ng-class="registerForm.vehicle_type == 'Van' ? 'blue' : ''" 
									class="hod-button">
									Van
								</button>
								<button 
									type="button" 
									ng-click="registerForm.vehicle_type = 'Truck'" 
									ng-class="registerForm.vehicle_type == 'Truck' ? 'blue' : ''" 
									class="hod-button">
									Truck
								</button>
							</div>
						</div>
					</div>
					<div class="section">
						<input type="text" class="gui-input" placeholder="Vehicle Year" ng-model="registerForm.vehicle_year" ng-required="['Car','Suv','Van'].indexOf(registerForm.vehicle_type) > -1">
					</div>
					<div class="section">
						<input type="text" class="gui-input" placeholder="Vehicle Make" ng-model="registerForm.vehicle_make" ng-required="['Car','Suv','Van'].indexOf(registerForm.vehicle_type) > -1">
					</div>
					<div class="section">
						<input type="text" class="gui-input" placeholder="Vehicle Model" ng-model="registerForm.vehicle_model" ng-required="['Car','Suv','Van'].indexOf(registerForm.vehicle_type) > -1">
					</div>
					<!-- <div class="section">
						<input type="text" class="gui-input" placeholder="Plate Number" ng-model="registerForm.plate_number" required>
					</div> -->
				</div>
				<div class="inner-register-form" ng-if="registerStep == 4">
					<h3>Background Check </h3>
					<div class="section">
						<input type="text" class="gui-input" placeholder="Driver’s License Number" ng-model="registerForm.license_number" required>
					</div>
					<div class="section">
						<input type="text" 
						class="gui-input" 
						placeholder="SSN Number" 
						ng-model="registerForm.ssn_number" 
						ui-mask="999-99-9999"  ui-mask-placeholder ui-mask-placeholder-char=" "
						required>
					</div>
					<div class="section">
						<p class="bg-desc">
							<small>
								We're required to run a background check for security reasons. <br><br>

								* This won't affect your credit score. <br>
								* Your information will be kept private and secure <br>
							</small>
						</p>
					</div>

					<div class="section">
						<p>Birthday</p>
						<div class="row">
							<div class="col-md-3 col-sm-3 col-xs-3 col-3 pr5">
								<input type="text" class="gui-input" placeholder="Month" ng-model="registerForm.birthday_month" 
								ui-mask="99"  ui-mask-placeholder ui-mask-placeholder-char=" "
								required>
							</div>
							<div class="col-md-4 col-sm-4 col-xs-4 col-4 pr5 pl5">
								<input type="text" class="gui-input" placeholder="Day" ng-model="registerForm.birthday_day" 
								ui-mask="99"  ui-mask-placeholder ui-mask-placeholder-char=" "
								required>
							</div>
							<div class="col-md-5 col-sm-5 col-xs-5 col-5 pl5">
								<input type="text" class="gui-input" placeholder="Year" ng-model="registerForm.birthday_year" 
								ui-mask="9999"  ui-mask-placeholder ui-mask-placeholder-char=" "
								required>
							</div>
						</div>
					</div>

					<div class="section">
						<a href="#" class="hod-button blue block" data-toggle="modal" data-target="#disclosure" >Background Check Disclosure</a>
						<a href="#" class="hod-button blue block mt10" data-toggle="modal" data-target="#authorization" >Authorization</a>
					</div>

					<div class="section">
						<p>Fair Credit Reporting Act (FCRA)</p>
						<div class="credit-area">
							<p>
								Para información en español, visite www.consumerfinance.gov/learnmore o escribe a la
								Consumer Financial Protection Bureau, 1700 G Street N.W., Washington, DC 20552.
								A Summary of Your Rights Under the Fair Credit Reporting Act
								The federal Fair Credit Reporting Act (FCRA) promotes the accuracy, fairness, and
								privacy of information in the files of consumer reporting agencies. There are many types of
								consumer reporting agencies, including credit bureaus and specialty agencies (such as agencies
								that sell information about check writing histories, medical records, and rental history records).
								Here is a summary of your major rights under FCRA. For more information, including
								information about additional rights, go to www.consumerfinance.gov/learnmore or write
								to: Consumer Financial Protection Bureau, 1700 G Street N.W., Washington, DC 20552.
								* You must be told if information in your file has been used against you. Anyone who
								uses a credit report or another type of consumer report to deny your application for credit,
								insurance, or employment – or to take another adverse action against you – must tell you,
								and must give you the name, address, and phone number of the agency that provided the
								information.
								* You have the right to know what is in your file. You may request and obtain all the
								information about you in the files of a consumer reporting agency (your “file
								disclosure”). You will be required to provide proper identification, which may include
								your Social Security number. In many cases, the disclosure will be free. You are entitled
								to a free file disclosure if:
								o a person has taken adverse action against you because of information in your
								credit report;
								o you are the victim of identity theft and place a fraud alert in your file;
								o your file contains inaccurate information as a result of fraud;
								o you are on public assistance;
								o you are unemployed but expect to apply for employment within 60 days.
								In addition, all consumers are entitled to one free disclosure every 12 months upon
								request from each nationwide credit bureau and from nationwide specialty consumer
								reporting agencies. See www.consumerfinance.gov/learnmore for additional
								information.
								* You have the right to ask for a credit score. Credit scores are numerical summaries of
								your credit-worthiness based on information from credit bureaus. You may request a
								credit score from consumer reporting agencies that create scores or distribute scores used
								in residential real property loans, but you will have to pay for it. In some mortgage
								transactions, you will receive credit score information for free from the mortgage lender.
								* You have the right to dispute incomplete or inaccurate information. If you identify
								information in your file that is incomplete or inaccurate, and report it to the consumer
							</p>
						</div>
					</div>

					<div class="section">
						<label class="option option-info block mn ml4">
							<input type="checkbox" name="deleted" ng-model="registerForm.bgc_status" required>
							<span class="checkbox mn"></span> 
							<span style="color:#828c95;line-height: 24px">By clicking “Check box”, I confirm that I have read and agree to the documents above containing the FCRA, Background Check Disclosure and Authorization. I authorize HODXpress to order consumer reports about me. I also understand that I will automatically receive a free copy of my consumer report once it is completed. </span>
						</label>
					</div>
				</div>
				<div class="inner-register-form" ng-if="registerStep == 5 && !signStatus">
					<h3>W-9 Form </h3>
					<div class="section">
						<p>Please click below button to fill out your individual W-9 form on Docusign so that you can paid;</p>
					</div>
					<div class="section">
						<button 
							type="button" 
							class="hod-button blue block"
							ng-click="openW9Form()"
							ng-disabled="disableW9Button">
							Complete W-9 Form
						</button>
					</div>
					<div class="section">
						<p>HODXpress uses a W-9 form to accurately report your earnings as an Independent Contractor to the IRS.</p>
					</div>
				</div>
				<div class="inner-register-form" ng-if="registerStep == 5 && signStatus">
					<h3 style="color:#888c90">
						Digital Sign with 
						<img src="/img/helloworks.png" alt="" width="140px">	
					</h3>
					<div class="section">
						<p>Helloworks has sent you an email. Please click "Get Started" to complete your digital signature for W-9 and continue with the sign-up process.</p>
					</div>
				</div>
				<div class="inner-register-form" ng-if="registerStep == 6">
					<h3>Bank Account </h3>
					<div class="section">
						<input type="text" class="gui-input" placeholder="Account Holder Name" ng-model="registerForm.account_name" required>
					</div>
					<div class="section">
						<input type="text" class="gui-input" placeholder="Routing Number" ng-model="registerForm.routing_number" required>
					</div>
					<div class="section">
						<input type="text" class="gui-input" placeholder="Account Number" ng-model="registerForm.account_number" required>
					</div>
				</div>
				<div class="inner-register-form" ng-if="registerStep == 7">
					<div class="row text-center">
						<div class="col-md-12 text-center">
							<img src="/landing/img/sucess-small.svg" alt="">
						</div>
					</div>
					<h3 class="text-center">Download our app to complete these steps </h3>
					<div class="row text-center">
						<div class="col-md-6 col-xs-6 col-6">
							<img src="/landing/img/upload-selife.svg" alt="">
							<p>Upload Selfie</p>
						</div>
						<div class="col-md-6 col-xs-6 col-6">
							<img src="/landing/img/verify-your-identy.svg" alt="">
							<p>Verification Your ID</p>
						</div>
					</div>
				</div>
				<div class="section">
					<button 
						type="button" 
						ng-click="registerBack()" 
						ng-if="registerStep > 1 && registerStep != 7"
						ng-show="!signStatus"
						class="hod-button pull-left">
						<img src="/landing/img/arrow-left-line.svg" alt="">
					</button>
					<button 
						type="submit"
						ng-if="registerStep != 7 && !registerLoading"
						ng-show="!signStatus"
						ng-disabled="!nextDisabled()"
						class="hod-button blue pull-right">Next</button>
					<button 
						type="button"
						ng-if="registerStep != 7 && registerLoading"
						ng-disabled="true"
						class="hod-button blue pull-right">Sending...</button>
				</div>
				<div class="clearfix"></div>
			</form>
		</div>

		<div class="panel-footer p20" ng-if="registerStep == 7">
			<div class="row">
				<div class="col-md-6 col-xs-6 col-sm-6 col-6">
					<img src="/landing/img/app-store.svg" alt="">
				</div>
				<div class="col-md-6 col-xs-6 col-sm-6 col-6" style="padding-top:0px">
					<a href="https://play.google.com/store/apps/details?id=com.imestav.hodxpress">
						<img src="/landing/img/google-play.svg" alt="">
					</a>
				</div>
			</div>
		</div>

		<div class="modal info-box" id="successBox" role="dialog">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-body">
						<div class="success-box">
							<img src="/img/sucess-icon.svg">
							<h3>
								{{ successBoxMessage }}
							</h3>
							<a href="#" class="btn" data-dismiss="modal" ng-click="registerStep = 7">
								Done
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<br> <br>
	<div class="col-md-12 footer-links driver-footer" style="margin:0px; padding:0px; margin-top:15px;width:100%">
		<div class="col-md-6 footer-copy">
			<p>© 2024 HODXpress</p>
		</div>
		<div class="col-md-6 footer-copy footer-links">
			<ul>
				<li>
					<a href="/driver-privacy-policy">Privacy</a>
				</li>
				<li>
					<a href="/driver-privacy-policy">Agreement</a>
				</li>
			</ul>
		</div>
	</div>

	<div class="modal" 
		id="docuSignModal" 
		tabindex="-1" 
		role="dialog" 
		aria-labelledby="docuSignModalLabel">
		<div class="modal-dialog modal-lg" style="width:100%;margin:0 auto" role="document">
			<div class="modal-content">
				<div class="modal-body">
					<iframe
					id="dswpf" 
					style="width: 100%; height: 700px;"
					ng-src="{{ docusignUrl | trusted }}"></iframe>
				</div>
				<!-- <div class="modal-footer">
					<a href="#" class="btn btn-primary" ng-click="completeDocusign()">Complete</a>
				</div> -->
			</div>
		</div>
	</div>
	
	
	<div class="modal" 
		id="authorization" 
		tabindex="-1" 
		role="dialog" 
		aria-labelledby="authorizationLabel">
		<div class="modal-dialog modal-lg" style="width:60%;margin:0 auto" role="document">
			<div class="modal-content">
				<div class="modal-body">
					<iframe 
						src="https://docs.google.com/viewer?url=https://hodxpress.com/Acknowledgement_and_Authorization.pdf&embedded=true" 
						width="100%" 
						height="100%" 
						style="width: 100%; height: 100%;" 
						frameborder="0" 
						scrolling="no">
					</iframe>
				</div>
				<div class="modal-footer">
					<a href="#" class="btn btn-primary" data-dismiss="modal">Close</a>
				</div>
			</div>
		</div>
	</div>
	<div class="modal" 
		id="disclosure" 
		tabindex="-1" 
		role="dialog" 
		aria-labelledby="disclosureLabel">
		<div class="modal-dialog modal-lg" style="width:60%" role="document">
			<div class="modal-content">
				<div class="modal-body">
					<iframe 
						src="https://docs.google.com/viewer?url=https://hodxpress.com/Disclosure.pdf&embedded=true" 
						width="100%" 
						height="100%" 
						style="width: 100%; height: 100%;" 
						frameborder="0" 
						scrolling="no">
					</iframe>
				</div>
				<div class="modal-footer">
					<a href="#" class="btn btn-primary" data-dismiss="modal">Close</a>
				</div>
			</div>
		</div>
	</div>
</div>
